import * as React from 'react';

import Markdown from 'bundles/cms/components/Markdown';
import type { Maybe } from 'bundles/xddp/__generated__/baseContentfulTypes';

type PaymentOptionsLinkProps = {
  tuitionLinkText: Maybe<string> | undefined;
};

export const PaymentOptionsLink = ({ tuitionLinkText }: PaymentOptionsLinkProps) => {
  return <Markdown disallowedTypes={['paragraph']} unwrapDisallowed source={tuitionLinkText} />;
};
